import { TablePagination as MuiTablePagination, type TablePaginationProps as MuiTablePaginationProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

const ROOT_ELEMENT = 'div';

type Props = WithoutStyleOverrides<
  Omit<MuiTablePaginationProps<typeof ROOT_ELEMENT>, 'slots' | 'ActionsComponent' | 'onPageChange' | 'onRowsPerPageChange'>
> & {
  onPageChange: (page: number) => void;
  onRowsPerPageChange?: (rowsPerPage: number) => void;
};

export function TablePagination(props: Props) {
  const { onPageChange, onRowsPerPageChange, ...tablePaginationProps } = props;

  return (
    <MuiTablePagination
      {...tablePaginationProps}
      component={ROOT_ELEMENT}
      onPageChange={(_event, page) => onPageChange(page)}
      onRowsPerPageChange={onRowsPerPageChange === undefined
        ? undefined
        : (event) => onRowsPerPageChange(Number(event.target.value))}
    />
  );
}

export type { Props as TablePaginationProps };
